export const headers = [
  { label: "User", key: "user" },
  { label: "Role", key: "role" },
  { label: "Last active", key: "lastActive" },
  { label: "Action", key: "action" }
];
